import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useI18n } from "@/context/LangContext";
import { pickLocalized } from "@/lib/i18n";

export default function DeleteDialog({ open, onOpenChange, item, onConfirm }) {
  const { lang, t } = useI18n();
  const name = item ? pickLocalized(item, "name", lang) : "";
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        className="bg-white border border-[#e5e3db] rounded-none"
        data-testid="delete-dialog"
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="serif text-2xl font-bold text-[#1a1a1a]">
            {t("delete.title")}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-[#5c5c5c]">
            {t("delete.body.a")} <strong>{name}</strong>. {t("delete.body.b")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            className="rounded-none border-[#e5e3db]"
            data-testid="delete-cancel-btn"
          >
            {t("delete.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="rounded-none bg-[#d32f2f] hover:bg-[#a72424] text-white"
            data-testid="delete-confirm-btn"
          >
            {t("delete.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
